module.exports = __webpack_public_path__ + "img/saint_lucia.3b8050d.webp";